export const environment = {
  production: false,
  name: 'testing',
  // apiUrl: 'http://localhost:3000/api/v1/',
  // apiUrl: 'http://192.168.50.197:3000/api/v1/',
//   apiUrl: 'https://api.drinkhopping.com/api/v1/',
  apiUrl: 'https://testing-drinkhopping-api-zvzp.onrender.com/api/v1/'

};
